/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import Icon from "react-icons-kit";
import { circle } from "react-icons-kit/fa/circle";
import { angleRight } from "react-icons-kit/fa/angleRight";

import { Checkbox, ExploreLink, Text } from "UpduoLibrary";
import { getGraphColor } from "config/Utilities";
import {
  skaleLinkBlue,
  skaleWebBorderGray,
  skaleWebFillGray,
  skaleWebFillLightGray,
  skaleWebTextGray,
} from "config/UpduoColors";

export default function GraphSidebarRow({
  itemType,
  item,
  rowIndex,
  isActive,
  onSelectPlot,
}) {
  let link = "";
  if (itemType === "skills") {
    link = `/content/lesson/${item.id}`;
  } else {
    if (itemType !== null) {
      const itemType1 = itemType.slice(0, -1);
      link = `/dashboard/${itemType1}/${item.id}`;
    }
  }
  return (
    <View
      style={{
        flexDirection: "row",
        borderBottomWidth: 1,
        borderColor: skaleWebBorderGray,
      }}
    >
      <View
        style={{
          width: 20,
          backgroundColor: skaleWebFillLightGray,
          borderRightWidth: 1,
          borderColor: skaleWebBorderGray,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Text style={{ alignSelf: "center", fontSize: 10 }}>{rowIndex}</Text>
      </View>
      <View
        style={{
          width: "90%",
          paddingLeft: 2,
          flexDirection: "row",
          alignItems: "center",
          margin: 5,
        }}
      >
        <div
          style={{
            color: isActive
              ? getGraphColor(item.name, rowIndex - 1)
              : skaleWebFillGray,
            paddingBottom: 2.5,
          }}
        >
          <Icon size={15} icon={circle} />
        </div>
        <View style={{ width: 10 }} />
        <Text
          style={{
            flex: 1,
            flexWrap: "wrap",
            width: "100%",
            color: skaleWebTextGray,
          }}
        >
          {item.name}
        </Text>
        <View
          style={{ flexDirection: "row", alignItems: "center", height: 25 }}
        >
          <Checkbox
            checked={isActive}
            onClick={() => {
              onSelectPlot(item.id);
            }}
          />
          {itemType === "skills" ? null : (
            <ExploreLink
              content={
                <div
                  style={{
                    color: skaleLinkBlue,
                    paddingBottom: 2.5,
                  }}
                >
                  <Icon size={20} icon={angleRight} />
                </div>
              }
              to={link}
            />
          )}
        </View>
      </View>
    </View>
  );
}
